import * as yup from 'yup';

import { ContractingPartyToContractV1Dto } from '@/openapi';

export const getContractSchema = (t: (key: string) => string) =>
  yup.object({
    name: yup.string().required(t('errors.required')),
    startDate: yup.date().required(t('errors.required')),
    contractTypeId: yup.string().required(t('errors.required')),
    customerId: yup.string().required(t('errors.required')),
    endDate: yup.date().required(t('errors.required')),
    areasWithPartnerAndCaretaker: yup
      .array()
      .min(1, t('errors.required'))
      .required(t('errors.required')),
  });

export const initialContractValues = {
  areasWithPartnerAndCaretaker: [],
};

export const getNewAreaValue = () => ({
  areaId: '',
  partnerPartyId: '',
  partnerRole: ContractingPartyToContractV1Dto.role.PROPERTY_LANDLORD,
  partnerGroupId: '',
  caretakerRole: ContractingPartyToContractV1Dto.role.PROPERTY_MANAGER,
  partnerId: '',
});

export const getContractToDocumentsSchema = (t: (key: string) => string) =>
  yup.object({
    documentId: yup.string().required(t('errors.required')),
  });
